import * as React from "react";
import { forwardRef } from "react";
const SvgWallet = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 56 56", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M44.333 16.333v-7A2.333 2.333 0 0 0 42 7H11.667A4.667 4.667 0 0 0 7 11.667m0 0a4.667 4.667 0 0 0 4.667 4.666h35A2.333 2.333 0 0 1 49 18.667V28M7 11.667v32.666A4.667 4.667 0 0 0 11.667 49h35A2.333 2.333 0 0 0 49 46.667v-9.334M49 28h-7a4.667 4.667 0 0 0 0 9.333h7M49 28a2.333 2.333 0 0 1 2.333 2.333V35A2.333 2.333 0 0 1 49 37.333" }));
const ForwardRef = forwardRef(SvgWallet);
export { ForwardRef as ReactComponent };
